





























































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import RiskSearch from '@/app/components/Risk/RiskSearch.vue'
import RiskListHeader from '@/app/components/Risk/RiskListHeader.vue'
import RiskList from '@/app/components/Risk/RiskList.vue'
/* api */
import riskListApi from '@/app/model/api/riskListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    RiskSearch,
    RiskListHeader,
    RiskList
  }
})
export default class risk extends Vue {
  private count: number = 0
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private complateMessage: string = this.$store.state.alertState.message
  private riskData: any = {}

  created () {
    this.getRiskList()
  }

  private getRiskList () {
    (async () => {
      /* 初期表示は名前の昇順 */
      const data = {
        word: this.$store.state.riskState.searchText,
        order_name: this.$store.state.riskState.orderName,
        sort: this.$store.state.riskState.sortAsc
      }

      const result = await riskListApi.getRiskList(data)

      if (result.isOk()) {
        this.riskData = result.getPayload().results
        // システム定義以外のリスク数をカウント
        let count = 0
        for (let i in this.riskData) {
          if (!this.riskData[i].is_constant_risk) {
            count++
          }
        }
        this.count = count
        if (this.count === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false

          for (let i in this.riskData) {
            let items = []
            for (let j in this.riskData[i].harvest_risk_items) {
              items.push(this.riskData[i].harvest_risk_items[j].risk_item_name)
            }
            this.riskData[i].risk_items = items.join(', ')
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private doRiskSort (data: string) {
    this.showLoading = true
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.riskState.orderName) {
      if (this.$store.state.riskState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('riskState/setOrderName', data)
    this.$store.commit('riskState/setSortAsc', sort)
    this.getRiskList()
  }

  private changeList () {
    this.showLoading = true
    this.$store.commit('plantState/setOrderName', 'created_at')
    this.$store.commit('plantState/setSortAsc', false)
    this.scrollTop()
    this.getRiskList()
  }

  private scrollTop () : any {
    let riskArea: any = document.getElementById('listContainer')!
    riskArea.scrollTop = 0
  }
}
